import script from "./Bottom.vue?vue&type=script&lang=ts"
export * from "./Bottom.vue?vue&type=script&lang=ts"

import "./Bottom.vue?vue&type=style&index=0&id=6b98a54e&lang=css"

export default script